const getScreenSize = ({ fov = 45, aspect = 1, dist = 1 } = {}) => {
  var vFOV = (fov / 180) * Math.PI // convert vertical fov to radians
  var height = 2 * Math.tan(vFOV / 2) * dist // visible height
  var width = height * aspect // visible width

  return { width, height }
}

export default getScreenSize
